import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

export function StatusBadge({ status }) {
  const map = {
    SUCCESS: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
    PENDING: "bg-amber-50 text-amber-700 ring-amber-600/20",
    FAILED: "bg-red-50 text-red-700 ring-red-600/20",
    ON_TRACK: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
    DUE_SOON: "bg-amber-50 text-amber-700 ring-amber-600/20",
    CLOSED: "bg-slate-100 text-slate-600 ring-slate-500/20",
    Open: "bg-blue-50 text-blue-700 ring-blue-600/20",
    "In Progress": "bg-amber-50 text-amber-700 ring-amber-600/20",
    Resolved: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
    Closed: "bg-slate-100 text-slate-600 ring-slate-500/20",
  };
  const label = { ON_TRACK: "On Track", DUE_SOON: "Due Soon", CLOSED: "Closed" }[status] || status;
  return (
    <span data-testid="status-badge" className={cn("inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-semibold ring-1 ring-inset", map[status] || "bg-slate-100 text-slate-600 ring-slate-500/20")}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}

export function PenguinIcon({ size = 16, className }) {
  return <img src="/brand/zrope-penguin.png" alt="ZRo Pe" style={{ width: size, height: size, objectFit: "contain" }} className={className} />;
}

export function EmptyState({ icon: Icon, title, desc, action, mascot }) {
  return (
    <div data-testid="empty-state" className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-200 bg-white px-6 py-14 text-center">
      {mascot ? <img src="/brand/zrope-mascot.png" alt="ZRo Pe" className="mb-4 h-20 w-20 object-contain opacity-90" />
        : Icon && <div className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-emerald-50 text-[#14B8A6]"><Icon className="h-7 w-7" /></div>}
      <h3 className="font-display text-lg font-bold text-[#0B132B]">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-slate-500">{desc}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Skeleton({ className }) {
  return <div className={cn("animate-pulse rounded-md bg-slate-200/70", className)} />;
}

export function Spinner({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-slate-400">
      <Loader2 className="h-5 w-5 animate-spin" /> <span className="text-sm">{label}…</span>
    </div>
  );
}

export function Progress({ value, className }) {
  return (
    <div className={cn("h-2 w-full overflow-hidden rounded-full bg-slate-100", className)}>
      <div className="h-full rounded-full bg-[#14B8A6] transition-all" style={{ width: `${Math.min(100, Math.max(0, value))}%` }} />
    </div>
  );
}

export function Stat({ label, value, sub, tone = "light" }) {
  return (
    <div className={cn("rounded-lg border p-4", tone === "dark" ? "border-white/10 bg-white/5" : "border-slate-200 bg-white shadow-sm")}>
      <p className={cn("text-xs font-medium", tone === "dark" ? "text-slate-400" : "text-slate-500")}>{label}</p>
      <p className={cn("mt-1 font-display text-2xl font-bold tracking-tight", tone === "dark" ? "text-white" : "text-[#0B132B]")}>{value}</p>
      {sub && <p className={cn("mt-0.5 text-xs", tone === "dark" ? "text-slate-400" : "text-slate-400")}>{sub}</p>}
    </div>
  );
}
